import { API_BASE_URL } from '@/lib/apiBase'
import { topWindow } from './topWindow'

const NEXT_BASE = 'https://app.invalid'

/** A same-app path, or undefined: whatever the browser resolves it to (`//host`, `/\host`, `/\t/host`) stays on the app's origin. */
export function safeNext(next: string | null | undefined): string | undefined {
  if (!next?.startsWith('/')) return undefined
  try {
    return new URL(next, NEXT_BASE).origin === NEXT_BASE ? next : undefined
  } catch {
    return undefined
  }
}

/**
 * Full-page navigation to the backend, which picks the IdP, keeps state + PKCE
 * in an httpOnly cookie and redirects to Cognito. The SPA holds no SSO secrets.
 */
export function startSso({ email, idp, next }: { email?: string; idp?: string; next?: string } = {}): void {
  const qs = new URLSearchParams()
  if (email) qs.set('email', email)
  if (idp) qs.set('idp', idp)
  const path = safeNext(next)
  if (path) qs.set('next', path)
  const query = qs.toString()
  // The whole page, also from inside the iPad stage's frame: identity
  // providers refuse to be framed.
  topWindow().location.assign(`${API_BASE_URL}/auth/sso/start${query ? `?${query}` : ''}`)
}

const SSO_ERRORS: Record<string, string> = {
  NO_ACCOUNT: 'No smart-cgt account for this email, contact your administrator.',
  SSO_DISABLED: 'Single sign-on is not enabled.',
  SSO_NOT_SET_UP: "Single sign-on isn't set up for your email domain. Sign in with your password.",
}

/** The message for an SSO error code from the backend or `?error=`; null when there is none. */
export function ssoErrorMessage(code: string | null | undefined): string | null {
  if (!code) return null
  return SSO_ERRORS[code] ?? 'SSO sign-in failed.'
}
